export default __webpack_public_path__ + "static/media/Jerkin of the Death Master (nm).c32ed4de.jpg";